import React from 'react';
import { Row, Col, Button } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import ConvertibleText from '../../components/shared/ConvertibleText'
import Deductible from './Deductible'
import {getDeductible} from './getDeductible'

class DeductibleContainer extends React.Component {
  constructor(props) { 
    super(props);
    
    const isNYDeductible = props.isNYDeductible;
    const defaultDeductibles = getDeductible(isNYDeductible, props.projectState, props.demoCost, props.isDemolitionDetailsInterior, props.contractor);
    const deductibles = !!props.deductibles ? props.deductibles : defaultDeductibles;
    this.state = {
      deductibles
    };

    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.addDeductible = this.addDeductible.bind(this);
    this.deleteDeductible = this.deleteDeductible.bind(this);
  }

  componentDidMount(){
    const {deductibles} = this.state;
    this.props.onBlurHandler({deductibles});
    
  }
  onBlurHandler(key,lable,text) {
    const {deductibles} = this.state;
    const updatedDeductibles = deductibles.map(deductible=>{
      if(deductible.key===key){
        return {
          key,
          lable,
          text
        }
      }
      return deductible;
    });
    this.setState({deductibles:updatedDeductibles});
    this.props.onBlurHandler({deductibles:updatedDeductibles});
  }

  addDeductible(){
    const {deductibles} = this.state;
    const nextKey =  Math.max.apply(Math, deductibles.map(deductible=>deductible.key))+1;
    const nextDeductible = {
      key:nextKey,
      label:'',
      text:'0'
    };
    deductibles.push(nextDeductible);
    this.setState({deductibles});
    this.props.onBlurHandler({deductibles});
  }

  deleteDeductible(key){
    const {deductibles} = this.state;
    const updatedDeductibles = deductibles.filter(deductible=>deductible.key!==key);
    this.setState({deductibles:updatedDeductibles});
    this.props.onBlurHandler({deductibles:updatedDeductibles});
  }

  render() {
    const {deductibles} = this.state;
    const isModified = false;
    const manuallySetPricing = true;
    const deductibleList = deductibles.map(deductible => {
      return (
        <Deductible
          manuallySetPricing={manuallySetPricing}
          isModified={isModified}
          name={deductible.lable}
          text={deductible.text}
          onBlurHandler={this.onBlurHandler}
          key={deductible.key}
          onDelete={this.deleteDeductible}
          onDeleteShow={deductible.key!==1}
          id={deductible.key}
        />
      )
    });
    return (
      <div>
        <div className="list-header gcLimitsContainer">
          <h4 className="list-title">Deductibles</h4>
          <button className="list-add" onClick={this.addDeductible}>
            <i className="fa fa-plus-circle fa-lg" title="Add Deductible" aria-hidden="true" />
          </button>
        </div>
        {deductibleList}
      </div>
    )
  }
}

export default DeductibleContainer